import { styled } from '@mui/material';
import { Paper as MuiPaper } from '@mui/material';

export const Paper = styled(MuiPaper)(({ theme }) => ({
    borderRadius: '16px',
    background: `var(--background-Primary, ${theme.palette.dashboard.main})`,
    boxShadow: '0px 4px 80px 0px rgba(112, 144, 176, 0.14)',
    py: {
        xs: 3,
        md: 6,
    },
    px: {
        xs: 2,
        md: 5,
    },
}));
